import { render, staticRenderFns } from "./RichTextField.vue?vue&type=template&id=1b1d339c&scoped=true&"
import script from "./RichTextField.vue?vue&type=script&lang=ts&"
export * from "./RichTextField.vue?vue&type=script&lang=ts&"
import style0 from "./RichTextField.vue?vue&type=style&index=0&id=1b1d339c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1d339c",
  null
  
)

export default component.exports